exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-upload .display-image{position:relative;display:inline-flex}.image-upload .display-image img{width:10vh;height:10vh;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:all .3s cubic-bezier(0.25, 0.8, 0.25, 1);border:4px solid #fff;border-radius:5px}.image-upload .display-image img:hover{box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)}.image-upload .display-image .fa-times{display:none;position:absolute;right:4px;top:4px;background-color:gray;width:25px;height:25px;justify-content:center;align-items:center;border-bottom-left-radius:13px;transition:all .3s cubic-bezier(0.25, 0.8, 0.25, 1);color:#fff}.image-upload .display-image .fa-times:hover{cursor:pointer}.image-upload .display-image:hover .fa-times{display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/reusableComponents/ImageUpload/imageUpload.scss
// module id = 1739
// module chunks = 0